import React from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";

interface ButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  type?: "button" | "submit";
  loading?: boolean;
}

const Previous: React.FC<ButtonProps> = ({
  onClick,
  disabled = false,
  className = "",
  type = "button",
  children = "Previous",
  loading = false,
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled || loading}
      className={`w-fit font-Acumin text-[14px] rounded-[8px] px-4 sm:px-6  py-4 sm:py-3   font-bold flex justify-center items-center gap-2 sm:gap-3 bg-[#EAECF0] text-[#98A2B3]   transition-colors duration-300 hover:bg-[#EAECF0] hover:text-[#98A2B3] disabled:bg-gray-400 disabled:cursor-not-allowed ${className}`}
    >
      <MdOutlineArrowBackIos className="text-[16px] lg:inline" />
      <span className="font-Acumin leading-[16px] text-[14px] pt-[4px]">
        {children}
      </span>
    </button>
  );
};

export default Previous;
